var map = {
	"./button-secondary-normal.png": 51,
	"./button-secondary-normal@2x.png": 52
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;


//////////////////
// WEBPACK FOOTER
// ./img/btn ^\.\/button\-secondary\-normal.*\.png$
// module id = 109
// module chunks = d-game